import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-84438').catch(console.error);
